import React from 'react';
import styled from 'styled-components';
import UserIcon from '@catalogo/ui-americanas-desktop-svg/user-red.svg';
import Rec from './rec';

const Logged = ({ name, recommendedList, pageType }) => (
  <Wrapper>
    <LeftArea>
      <UserArea>
        <UserIcon width="50px" height="50px" />
        <Text>Olá, {name}</Text>
      </UserArea>
      <UserLinks>
        <Links>
          <Link href="https://cliente.americanas.com.br/minha-conta/pedidos">meus pedidos</Link>
        </Links>
        <Links>
          <Link href="https://cliente.americanas.com.br/minha-conta/">minha conta</Link>
        </Links>
        <Links>
          <Link href="https://www.americanas.com.br/listas/favoritos">favoritos</Link>
        </Links>
      </UserLinks>
    </LeftArea>
    <RecsArea>
      {recommendedList?.map(rec => (
        <Rec
          key={rec?.position}
          title={rec?.title}
          products={rec?.products}
          position={rec?.position}
          pageType={pageType}
        />
      ))}
    </RecsArea>
  </Wrapper>
);

const Wrapper = styled.div`
  height: 352px;
  width: 100%;
  border-radius: 4px;
  background: ${({ theme }) => theme.white};
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.12);
  border-left: 10px solid ${({ theme }) => theme.primaryColor};
  display: flex;
  justify-content: space-between;
  padding: 25px;
`;

const LeftArea = styled.div`
  display: flex;
  flex-direction: column;
  width: 200px;
  margin: 50px 20px;
`;

const UserArea = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 15px;
`;

const Text = styled.span`
  font-size: 21px;
  font-weight: bold;
  margin-left: 10px;
  color: ${({ theme }) => theme.grey.darker};
`;

const UserLinks = styled.ul`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-left: 30px;
`;

const Links = styled.li`
  list-style-type: disc;
`;

const Link = styled.a`
  text-decoration: underline;
  cursor: pointer;
`;

const RecsArea = styled.div`
  display: flex;
  flex-direction: row;
`;

export default Logged;
